export default __webpack_public_path__ + "static/media/sauced_vanilla_right.bc108e87.png";